"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing-review", className, styles.root),
        header: styling_1.mergeStyles("listing-review-header", styles.header),
        author: styling_1.mergeStyles("listing-review-author", styles.author),
        date: styling_1.mergeStyles("listing-review-date", styles.date),
        rating: styling_1.mergeStyles("listing-review-rating", styles.rating),
        body: styling_1.mergeStyles("listing-review-body", styles.body),
        content: styling_1.mergeStyles("listing-review-content", styles.content)
    };
});
exports.getClassNames = getClassNames;
